






































import { listFactory } from '@/main/pages';
import { Typ } from '@/modules/ciselnik/dilenske/typ';

import { NAME } from './constants';
import { store } from './store/list';
import { types } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		TypSelect: Typ.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				typkod: `${this.storeUri}/${types.mutations.NOVE_VOZY_TYP_KOD_LIST_SELECT_MAPPER}`,
			};
		},
		typkodFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Typkod: this.Typkod,
			};
		},
	},
});
